var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#markdown_svg__clip0_1628_7993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.315 5.448c0-1.067.865-1.932 1.932-1.932h24.16c2.107 0 3.405 1.368 3.764 1.802.07.085.142.17.22.248l12.44 12.44.01.01c.102.103 1.928 1.956 1.928 3.861v37.69a1.933 1.933 0 01-1.932 1.933h-40.59a1.933 1.933 0 01-1.932-1.933V5.448z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.248 2.016v1.5-1.5a3.433 3.433 0 00-3.434 3.432v54.12A3.433 3.433 0 0012.247 63h40.59a3.433 3.433 0 003.432-3.433h-1.5 1.5V21.877c0-1.391-.647-2.631-1.172-3.43a10.016 10.016 0 00-1.195-1.491s0 0 0 0l-.007-.007-.003-.003-12.44-12.44s0 0 0 0a2.191 2.191 0 01-.125-.144l-1.156.956 1.156-.956c-.454-.55-2.136-2.346-4.92-2.346H12.25h0-.002z",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.318 3.92v14.085c0 1.071.862 1.933 1.933 1.933h13.98a7.367 7.367 0 00-1.398-1.933L40.27 5.442c-.608-.77-1.285-1.236-1.933-1.521l-.019-.001z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.252 22.837a4.828 4.828 0 01-4.832-4.832V3.5l.988.015c1.062 0 1.911.405 1.911.405v14.085c0 1.071.862 1.933 1.933 1.933h13.98s.538.973.538 1.939v.96H40.252z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.815 35.344l-4.807-13.06H25.65l-4.784 12.993c-.652 1.797-.932 2.066-2.404 2.235v.988h5.402v-.988c-1.797-.225-2.01-.528-1.448-2.19l.797-2.291h5.694l.808 2.29c.573 1.652.337 1.966-1.448 2.19v.989h6.918v-.988c-1.404-.169-1.73-.438-2.37-2.168zm-9.187-3.526l2.415-7.008 2.448 7.008h-4.863zM17.541 44.5h30v3h-30zM17.541 51.5h30v3h-30z",
    fill: "#666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "markdown_svg__clip0_1628_7993"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.541 .5)",
    d: "M0 0h64v64H0z"
  })))));
}
export default SvgMarkdown;